import React from 'react';
import {
    Button,
    Form,
    Input,
    TextArea,
    Segment,
    Grid,
    Loader,
    Header,
    Radio,
    Select,
    Message,
    Card,
    Divider, Icon
} from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { DateTimePicker } from 'react-widgets';
import { ToastContainer } from 'react-toastify';


export default class DateQuestionPreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            answerDate: new Date(),
            showDeleteButton: this.props.showDeleteButton,
            admin: !!((localStorage.getItem('activeRole').startsWith('Administrator') || localStorage.getItem('activeRole').startsWith('QA admin:')))
        };
        this.handleDateChange = this.handleDateChange.bind(this);
    }

    componentDidMount() {
        if (!this.state.admin && this.props.submitDateQuestion) {
            this.props.submitDateQuestion(
                this.props.questionId,
                this.state.answerDate,
                this.props.staff,
                this.props.typeName
            );
        }
    }


    handleDateChange(name, date) {
        this.setState({
            [name]: date
        }, !this.state.admin ?
            () => this.props.submitDateQuestion(this.props.questionId, date, this.props.staff, this.props.typeName) : () => {});
    }

    render() {
        let question = {
            text: this.props.text,
            questionId: this.props.questionId,
            typeName: this.props.typeName,
        };
        return (
            <div>

                <Header as="h4"><span style={{ color: 'red' }}>* &nbsp;</span> {question.text} {this.props.showDeleteButton && <Header as="h5" floated="right" ><span style={{ fontSize: '15px' }}>
                    <Icon name="trash alternate" link onClick={() => { this.props.deleteQuestion(question.questionId); }} > </Icon>

                </span></Header>}</Header>
                <Form>
                    <Grid columns={2} stackable >
                        <Grid.Column width={3} stretched>
                            <Form.Field
                                required
                                control={DateTimePicker}
                                format="D. M. YYYY."
                                defaultValue={new Date()}
                                value={this.state.answerDate}
                                time={false}
                                onChange={this.handleDateChange.bind(null, 'answerDate')}
                                style={{ borderWidth: '0px' }}
                                error={this.state.answerDateErr}
                            />
                        </Grid.Column>

                    </Grid>
                </Form>
                {this.props.showDivider && <Divider />}

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/AdminPoll/QuestionPreviews/DateQuestionPreview.js